module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "420"
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-card', {
    staticClass: "dialog-token"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("lock")]), _vm._v(" Cambiar mi contraseña\n      "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword($event)
      }
    }
  }, [_c('v-card-text', [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "color": "info",
      "icon": "info",
      "value": "true"
    }
  }, [_vm._v("Haga click en "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("visibility")]), _vm._v(" para poder\n          ver/ocultar su contraseña.")], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Antigua contraseña",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nueva contraseña",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100"
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPassword", $$v)
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("lock")]), _vm._v(" Cambiar")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef3d87c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/account/AccountPass.vue
// module id = 511
// module chunks = 2